exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-markdown-remark-fields-slug-js": () => import("./../../../src/pages/{MarkdownRemark.fields__slug}.js" /* webpackChunkName: "component---src-pages-markdown-remark-fields-slug-js" */)
}

